import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tag-list" }

import { ref, onMounted, onBeforeUnmount } from 'vue';
import TagsListItem from './TagsListItem.vue';


export default {
  __name: 'TagsList',
  setup(__props) {

const listTags = ref([]);
const searchBox = ref(null);
const searchInput = ref('');

function onChange(event) {
  const id = event.target.id;
  const label = event.target.labels[0]?.innerText || id;
  const isChecked = event.target.checked;

  if (isChecked) {
    if (!listTags.value.some(tag => tag.id === id)) {
      listTags.value.push({
        id,
        label,
      });
    }
  } else {
    listTags.value = listTags.value.filter(tag => tag.id !== id);
  }
}

function updateSearchTag(searchValue = '') {
  const id = 'search-box';
  const tagIndex = listTags.value.findIndex(tag => tag.id === id);

  if (searchValue) {
    if (tagIndex !== -1) {
      listTags.value[tagIndex].label = searchValue;
    } else {
      listTags.value.push({
        id,
        label: searchValue,
      });
    }
  } else if (!searchValue && tagIndex !== -1) {
    listTags.value.splice(tagIndex, 1);
  }
}

function fillListTags() {
  const tagItems = document.querySelectorAll(
    '.js-filter-blog-select-products input, .js-filter-blog-select-mutuals input, .js-filter-blog-select-subject input'
  );

  tagItems.forEach(tagItem => {
    const isChecked = tagItem.checked;
    const label = tagItem.labels[0]?.innerText || tagItem.id;
    if (tagItem.id && label && isChecked) {
      listTags.value.push({
        id: tagItem.id,
        label,
      });
    }
  });
}

function initEventListener() {
  const tagItems = document.querySelectorAll(
    '.js-filter-blog-select-products input, .js-filter-blog-select-mutuals input, .js-filter-blog-select-subject input'
  );

  tagItems.forEach(tagItem => {
    tagItem.addEventListener('change', onChange);
  });

  searchBox.value = jQuery('.filter-blog__search-field input');
  if (searchBox.value.length >= 1) {
    searchInput.value = searchBox.value.get(0).value;
    updateSearchTag(searchInput.value)
  }
}

function deleteEventListener() {
  const tagItems = document.querySelectorAll(
    '.js-filter-blog-select-products input, .js-filter-blog-select-mutuals input, .js-filter-blog-select-subject input'
  );

  tagItems.forEach(tagItem => {
    tagItem.removeEventListener('change', onChange);
  });
}

function removeTag(tag) {
  listTags.value = listTags.value.filter(target => target.id !== tag.id);
  const checkbox = document.getElementById(tag.id);

  if (checkbox) {
    checkbox.checked = false;
  }
  if (searchInput.value === tag.label) {
    searchInput.value = '';
    const searchField = document.querySelector('.filter-blog__search-field input');
    if (searchField) searchField.value = '';
    const searchContainer = document.querySelector('.filter-blog__search');
    if (searchContainer) searchContainer.classList.remove('extended');
  }
}

function iconPath(iconName) {
  return `/themes/custom/promutuel/dist/icons.svg#${iconName}`;
}

onMounted(() => {
  fillListTags();
  initEventListener();
});

onBeforeUnmount(() => {
  deleteEventListener();
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listTags.value, (item) => {
      return (_openBlock(), _createBlock(TagsListItem, {
        item: item,
        key: item.id,
        removeTag: removeTag,
        iconPath: iconPath
      }, null, 8 /* PROPS */, ["item"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

}